import {
  productPhotoPath,
  productPhotosPath,
  productReorderingPath,
  servicePhotoPath,
  servicePhotosPath,
  serviceReorderingPath,
} from "@travily/routes";
import type { PhotoManagerPaths } from "./use-photo-manager";

export const PRODUCT_PHOTO_PATHS: PhotoManagerPaths = {
  photo: productPhotoPath,
  photos: productPhotosPath,
  reordering: productReorderingPath,
};

export const SERVICE_PHOTO_PATHS: PhotoManagerPaths = {
  photo: servicePhotoPath,
  photos: servicePhotosPath,
  reordering: serviceReorderingPath,
};
